module.exports = __webpack_public_path__ + "static/media/person-dolly.c012168c.svg";